const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Comunicación Interna Empresarial — Chats de Equipo",
    summary:
      "Espacio de mensajería interna y privada exclusivo para los miembros y agentes de tu empresa. Facilita la coordinación en tiempo real, consultas rápidas entre compañeros sobre tickets de clientes y creación de salas grupales por departamento sin salir de BotMix.",
  },
  sections: [
    {
      id: "tipos_chats",
      title: "1. Modalidades de Conversación Interna",
      description:
        "Tipos de salas disponibles para el equipo de trabajo.",
      items: [
        {
          id: "chat_directo",
          title: "Chats Directos (1 a 1)",
          definition:
            "Conversación privada entre dos agentes de la empresa. Ideal para consultas puntuales o asistencia técnica entre supervisores y operadores.",
        },
        {
          id: "salas_grupales",
          title: "Salas Grupales (Departamentos)",
          definition:
            "Salas compartidas con múltiples participantes (ej: 'Equipo Ventas', 'Guardia de Soporte') para anuncios y coordinación de turnos.",
        },
      ],
    },
    {
      id: "funcionalidades_equipo",
      title: "2. Herramientas de Colaboración",
      description:
        "Opciones disponibles dentro de cada sala interna.",
      items: [
        {
          id: "notificaciones_lectura",
          title: "Confirmaciones de Lectura y Estado en Línea",
          definition:
            "Indicadores visuales que muestran si tus compañeros están activos y si leyeron el mensaje interno enviado.",
        },
        {
          id: "envio_archivos",
          title: "Intercambio de Capturas y Documentos",
          definition:
            "Envío rápido de imágenes, comprobantes o capturas de pantalla para consultar casos de clientes con supervisión.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "Official BotMix Guide",
    title: "Internal Team Communication — Team Chats",
    summary:
      "Private internal messaging space exclusively for your company members and agents. Facilitates real-time coordination, quick peer consultations on customer tickets, and department group room creation without leaving BotMix.",
  },
  sections: [
    {
      id: "tipos_chats",
      title: "1. Internal Conversation Modalities",
      description:
        "Types of chat rooms available for the work team.",
      items: [
        {
          id: "chat_directo",
          title: "Direct Chats (1-on-1)",
          definition:
            "Private conversation between two company agents. Ideal for quick inquiries or technical support between supervisors and operators.",
        },
        {
          id: "salas_grupales",
          title: "Group Rooms (Departments)",
          definition:
            "Shared rooms with multiple participants (e.g. 'Sales Team', 'Support Shift') for announcements and schedule coordination.",
        },
      ],
    },
    {
      id: "funcionalidades_equipo",
      title: "2. Collaboration Tools",
      description:
        "Options available within each internal chat room.",
      items: [
        {
          id: "notificaciones_lectura",
          title: "Read Receipts and Online Status",
          definition:
            "Visual indicators displaying whether your teammates are active and have read the dispatched internal message.",
        },
        {
          id: "envio_archivos",
          title: "Sharing Screenshots and Documents",
          definition:
            "Quick delivery of images, receipts, or screenshots to consult customer cases with supervisory staff.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Comunicação Interna Empresarial — Chats de Equipe",
    summary:
      "Espaço de mensagens internas e privadas exclusivo para membros e atendentes da sua empresa. Facilita a coordenação em tempo real, consultas rápidas entre colegas sobre tickets de clientes e criação de salas em grupo por departamento sem sair do BotMix.",
  },
  sections: [
    {
      id: "tipos_chats",
      title: "1. Modalidades de Conversa Interna",
      description:
        "Tipos de salas disponíveis para a equipe de trabalho.",
      items: [
        {
          id: "chat_directo",
          title: "Chats Diretos (1 para 1)",
          definition:
            "Conversa privada entre dois agentes da empresa. Ideal para dúvidas pontuais ou assistência técnica entre supervisores e operadores.",
        },
        {
          id: "salas_grupales",
          title: "Salas em Grupo (Departamentos)",
          definition:
            "Salas compartilhadas com múltiplos participantes (ex: 'Equipe de Vendas', 'Plantão de Suporte') para comunicados e alinhamento de turnos.",
        },
      ],
    },
    {
      id: "funcionalidades_equipo",
      title: "2. Ferramentas de Colaboração",
      description:
        "Recursos disponíveis dentro de cada sala interna.",
      items: [
        {
          id: "notificaciones_lectura",
          title: "Confirmações de Leitura e Status Online",
          definition:
            "Indicadores visuais que mostram se seus colegas estão ativos e se leram a mensagem interna enviada.",
        },
        {
          id: "envio_archivos",
          title: "Compartilhamento de Capturas e Documentos",
          definition:
            "Envio rápido de imagens, comprovantes ou prints de tela para consultar casos de clientes com a supervisão.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Communication Interne d'Entreprise — Chats d'Équipe",
    summary:
      "Espace de messagerie interne et privée réservé aux membres et conseillers de votre entreprise. Facilite la coordination en temps réel, les échanges rapides entre collègues au sujet des tickets clients et la création de salons de groupe par département sans quitter BotMix.",
  },
  sections: [
    {
      id: "tipos_chats",
      title: "1. Modalités de Conversation Interne",
      description:
        "Types de salons disponibles pour l'équipe de travail.",
      items: [
        {
          id: "chat_directo",
          title: "Discussions Directes (1 à 1)",
          definition:
            "Discussion privée entre deux collaborateurs de l'entreprise. Idéale pour les questions ponctuelles ou le support technique entre superviseurs et agents.",
        },
        {
          id: "salas_grupales",
          title: "Salons de Groupe (Départements)",
          definition:
            "Salons partagés avec plusieurs participants (ex: 'Équipe Commerciale', 'Permanence Support') pour les annonces et l'organisation des plannings.",
        },
      ],
    },
    {
      id: "funcionalidades_equipo",
      title: "2. Outils de Collaboration",
      description:
        "Options disponibles au sein de chaque salon interne.",
      items: [
        {
          id: "notificaciones_lectura",
          title: "Accusés de Lecture et Statut en Ligne",
          definition:
            "Indicateurs visuels précisant si vos collègues sont connectés et s'ils ont lu le message interne expédié.",
        },
        {
          id: "envio_archivos",
          title: "Partage de Captures et de Documents",
          definition:
            "Envoi rapide d'images, de reçus ou de captures d'écran pour analyser les dossiers clients avec la supervision.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "الدليل الرسمي لـ BotMix",
    title: "التواصل الداخلي للمؤسسة — محادثات الفريق",
    summary:
      "مساحة مراسلة داخلية وخاصة وحصرية لأعضاء ووكلاء شركتك. تيسر التنسيق المباشر في الوقت الفعلي، والاستشارات السريعة بين الزملاء بشأن تذاكر العملاء، وإنشاء غرف جماعية لكل قسم دون مغادرة BotMix.",
  },
  sections: [
    {
      id: "tipos_chats",
      title: "1. أنماط المحادثات الداخلية",
      description:
        "أنواع الغرف المتاحة لفريق العمل.",
      items: [
        {
          id: "chat_directo",
          title: "محادثات مباشرة (فرد لفرد)",
          definition:
            "محادثة خاصة بين وكيلين في الشركة. مثالية للاستفسارات السريعة أو الدعم الفني بين المشرفين والموظفين.",
        },
        {
          id: "salas_grupales",
          title: "غرف جماعية (الأقسام)",
          definition:
            "غرف مشتركة تضم عدة مشاركين (مثل: 'فريق المبيعات'، 'نوبة الدعم') للإعلانات وتنسيق المناوبات.",
        },
      ],
    },
    {
      id: "funcionalidades_equipo",
      title: "2. أدوات التعاون والعمل المشترك",
      description:
        "الخيارات المتاحة داخل كل غرفة داخلية.",
      items: [
        {
          id: "notificaciones_lectura",
          title: "تأكيدات القراءة وحالة الاتصال المباشر",
          definition:
            "مؤشرات مرئية تبين ما إذا كان زملاؤك نشطين وما إذا كانوا قد قرأوا الرسالة الداخلية المرسلة.",
        },
        {
          id: "envio_archivos",
          title: "تبادل لقطات الشاشة والمستندات",
          definition:
            "إرسال سريع للصور أو الإيصالات أو لقطات الشاشة للاستفسار عن حالات العملاء مع الإدارة الإشرافية.",
        },
      ],
    },
  ],
};

export const CHATS_HELP_DATA = {
  es,
  en,
  pt,
  fr,
  ar,
};
